import { render } from "./ComponentPopup.vue?vue&type=template&id=058ef88f&scoped=true"
import script from "./ComponentPopup.vue?vue&type=script&lang=js"
export * from "./ComponentPopup.vue?vue&type=script&lang=js"

import "./ComponentPopup.vue?vue&type=style&index=0&id=058ef88f&scoped=true&lang=css"

import exportComponent from "/home/cospexa/cospexa.webservice/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058ef88f"]])

export default __exports__